<template>
  <div>
    <div>
      <div v-if="filesDl.Id" class="leasing-summary">
        <div class="leasing-summary__head">
          <div class="leasing-summary__title">
            {{ form.contractNumber ? "Договор № " + form.contractNumber : "Договор" }}
          </div>
          <div v-if="form.contractDate" class="leasing-summary__supplier">
            от {{ dateMask(form.contractDate) }}
          </div>
        </div>

        <div class="leasing-summary__metrics leasing-summary__metrics_4">
          <div class="leasing-summary__metric">
            <div class="leasing-summary__label">Сумма договора</div>
            <div class="leasing-summary__value">
              {{ form.contractAmount ? moneyMask(form.contractAmount) : "&#8212;" }}
            </div>
          </div>
          <div class="leasing-summary__metric">
            <div class="leasing-summary__label">Аванс</div>
            <div class="leasing-summary__value">
              {{ form.advanceAmount ? moneyMask(form.advanceAmount) : "&#8212;" }}
            </div>
          </div>
          <div class="leasing-summary__metric">
            <div class="leasing-summary__label">Ежемесячный платеж</div>
            <div class="leasing-summary__value">
              {{ form.monthlyPayment ? moneyMask(form.monthlyPayment) : "&#8212;" }}
            </div>
          </div>
          <div class="leasing-summary__metric">
            <div class="leasing-summary__label">Акт приемки-передачи</div>
            <div class="leasing-summary__value">
              {{ form.date ? dateMask(form.date) : "&#8212;" }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="filesDl.Id">
        <div class="hr mt-3"></div>
        <div class="fw-bold pt-2">Договор лизинга</div>

        <!-- <div class="row mt-3">
          <div class="col-lg-6 note text-secondary">
            Раздел содержит полный пакет документов по сделке, включая платежные
            документы для оплаты, договоры и закрывающие документы. Переход к
            этапу получения предмета лизинга осуществляется после загрузки
            подписанных лизингополучателем документов и оплаты обязательных
            платежей.
          </div>
          <div class="col-lg-6 note text-secondary">
            При загрузке документов выполняется автоматическая проверка на
            соответствие формату и корректности содержимого. В случае, если
            документ не прошел автоматическую проверку, его необходимо
            подгрузить повторно, выполнив требования в описании к документу, для
            перехода к следующим шагам подписания сделки.
          </div>
        </div> -->
        <ui-table>
          <table class="table mt-3">
            <tbody>
              <tr>
                <td>
                  <div
                    v-if="filesDl.Status == 0"
                    class="text-danger text-nowrap"
                  >
                    Не принято
                  </div>
                  <div
                    v-if="filesDl.Status == 1"
                    class="text-success text-nowrap"
                  >
                    Принято
                  </div>
                </td>
                <td class="w-50 text-nowrap">
                  <router-link to="" @click="() => modalClose(filesDl.Id)"
                    >Договор лизинга</router-link
                  >
                </td>
                <td class="text-end">
                  <!-- <a class="text-nowrap d-block" href=""
                >Подписать ЭЦП ФНС России на сайте</a
              ><a class="text-nowrap d-block" href=""
                >Отправить в ЭДО "ТАКСКОМ"</a
              > -->

                  <div
                    v-if="filesDl.Status == 0"
                    class="d-flex flex-wrap gap-1 flex-nowrap justify-content-end"
                  >
                    <!-- <ui-button
                      @click="() => modalClose(filesDl.Id)"
                      class="btn btn-base btn-small"
                      :disabled="true"
                    >
                      Отправить в ЭДО
                    </ui-button> -->
                    <ui-button
                      @click="() => modalClose(filesDl.Id)"
                      class="btn btn-base btn-small"
                    >
                      Подписать ЭЦП
                    </ui-button>
                  </div>
                  <ui-button
                    v-if="filesDl.Status == 1"
                    @click="() => modalClose(filesDl.Id)"
                    class="btn btn-ghost btn-small"
                  >
                    Подробнее
                  </ui-button>
                </td>
              </tr>
            </tbody>
          </table>
        </ui-table>
      </div>

      <div v-else>
        <div class="leasings-alert leasings-success p-3 mt-4">
          <div class="leasings-success-title">
            Ваш договор лизинга и договор с поставщиком готовятся!
          </div>
          <div>
            Подписать документы вы сможете с помощью ЭЦП ФНС в этом личном
            кабинете. Ожидайте уведомление.
          </div>
        </div>
      </div>

      <div v-if="filesIn.Id">
        <div class="hr mt-3"></div>
        <div class="fw-bold pt-2">Счета</div>

        <ui-table>
          <table class="table mt-4">
            <tbody>
              <tr>
                <td class="w-50 text-nowrap">
                  <button @click="downloadIn(filesIn.Id)" class="btn-link">
                    <ui-loading-span v-if="loadingDownload" class="me-2" />

                    <i v-else class="icon-download me-2"></i>Счет на аванс
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </ui-table>
      </div>

      <!-- <div class="hr mt-3"></div>
    <div class="fw-bold pt-2">
      Назначение ответственного лица для получения предметов лизинга
    </div>

    <ui-table>
      <table class="table mt-4">
        <tbody>
          <tr>
            <td>
              <div class="text-success text-nowrap">Принято</div>
            </td>
            <td class="w-50 text-nowrap">
              <router-link :to="''"
                >Согласие на обработку персональных данных для
                ответственного</router-link
              >
            </td>
            <td class="text-end">
              <router-link :to="''" class="btn btn-ghost btn-small">
                Отправить ссылку
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </ui-table> -->

      <div v-if="filesActsb.Id">
        <div class="hr mt-3"></div>
        <div class="fw-bold py-2">Получение предметов лизинга</div>
        <div class="row mt-2">
          <div class="col-lg-8">
            <div class="mb-2">
              <b class="note"
                >Список документов, необходимых для получения предмета
                лизинга:</b
              >
            </div>
            <ol>
              <li class="mb-1 note">Паспорт</li>
              <li class="mb-1 note">
                Печать компании (кроме случаев получения материальных ценностей
                по разовой доверенности)
              </li>
            </ol>
            <div class="note">Дата и место передачи появятся ниже.</div>
          </div>
        </div>
        <div class="grid-table grid-table_col-2 mt-3 text-secondary">
          <div class="grid-table__item">Дата передачи ПЛ:</div>
          <div class="grid-table__item">
            {{ form.date ? dateMask(form.date) : "&#8212;" }}
          </div>
          <div class="grid-table__item">Место передачи ПЛ:</div>
          <div class="grid-table__item">
            {{ form.address ? form.address : "—" }}
          </div>
        </div>

        <div class="mt-3">
          <b class="note">Документы о приеме-передачи предмета лизинга</b>
        </div>

        <ui-table>
          <table class="table mt-0">
            <tbody>
              <tr>
                <td>
                  <div
                    v-if="filesActsb.Status == 0"
                    class="text-danger text-nowrap"
                  >
                    Не принято
                  </div>
                  <div
                    v-if="filesActsb.Status == 1"
                    class="text-success text-nowrap"
                  >
                    Принято
                  </div>
                </td>
                <td class="w-50 text-nowrap">
                  <router-link to="" @click="() => modalClose(filesActsb.Id)"
                    >Акт приемки-передачи к Договору лизинга</router-link
                  >
                </td>
                <td class="text-end">
                  <div
                    v-if="filesActsb.Status == 0"
                    class="d-flex flex-wrap gap-1 flex-nowrap justify-content-end"
                  >
                    <!-- <ui-button
                      @click="() => modalClose(filesActsb.Id)"
                      class="btn btn-base btn-small"
                      :disabled="true"
                    >
                      Отправить в ЭДО
                    </ui-button> -->
                    <ui-button
                      @click="() => modalClose(filesActsb.Id)"
                      class="btn btn-base btn-small"
                    >
                      Подписать ЭЦП
                    </ui-button>
                  </div>

                  <ui-button
                    v-if="filesActsb.Status == 1"
                    @click="() => modalClose(filesActsb.Id)"
                    class="btn btn-ghost btn-small"
                  >
                    Подробнее
                  </ui-button>
                </td>
              </tr>
              <tr v-if="commissioningCertificate">
                <td>
                  <div class="text-success text-nowrap">Принято</div>
                </td>
                <td class="w-50 text-nowrap">
                  <router-link to=""
                    ><i class="icon-download me-2"></i>Акт ввода в эксплуатацию
                    к Договору лизинга</router-link
                  >
                </td>
                <td class="text-end">
                  <ui-button @click="modalClose" class="btn btn-base btn-small">
                    Подписать ЭЦП
                  </ui-button>
                </td>
              </tr>
            </tbody>
          </table>
        </ui-table>
      </div>
    </div>

    <DocSign
      :modal="modal"
      @modalClose="modalClose"
      :docId="docId"
      :setStatus="setStatus"
      :status="statusTest"
      :data="props.filesDl"
    />
  </div>
</template>


<script setup>
import { ref, onMounted } from "vue";

import { postApi, downloadApi, moneyMask, dateMask, uploadApi } from "@/run";

import DocSign from "./DocSign.vue";

const props = defineProps({
  leasing: {
    type: Object,
    default: () => ({}),
  },
  filesDl: {
    type: Object,
    default: false,
  },
  filesIn: {
    type: Object,
    default: false,
  },
  filesActsb: {
    type: Object,
    default: false,
  },
});

const form = ref({
  contractNumber: null,
});

const setStatus = (docId, status, inn) => {
  if (props?.filesDl && props.filesDl.Id == docId) {
    props.filesDl.Status = status;

    // Проверяем, есть ли users
    if (props.filesDl.data?.users) {
      const user = props.filesDl.data.users.find((u) => u.inn === inn);
      if (user) {
        user.sign = new Date(); // добавляем объект sign с текущей датой
      }
    }
  } else if (props?.filesActsb && props.filesActsb.Id == docId) {
    props.filesActsb.Status = status;
  }
};

onMounted(() => {
  console.log(props.filesDl.DocFile);

  if (props.leasing?.JSONData) {
    try {
      const data = JSON.parse(props.leasing.JSONData);
      console.log(data);

      Object.assign(form.value, data);
    } catch (e) {
      console.error("Ошибка парсинга JSONData:", e);
    }
  }
});

const modal = ref(false);
const statusTest = ref(false);

const modalClose = (id) => {
  docId.value = id;

  if (props?.filesDl && props.filesDl.Id == id) {
    statusTest.value = props.filesDl.Status;
  } else if (props?.filesActsb && props.filesActsb.Id == id) {
    statusTest.value = props.filesActsb.Status;
  }

  modal.value = !modal.value;
};

const docId = ref(false);

const dl = ref(false);

const invoices = ref(false);

const acceptanceСertificate = ref(false);
const commissioningCertificate = ref(false);

const progressDownload = (id, progress) => {
  console.log(id, progress);
};

const loadingDownload = ref(false);

const downloadIn = (id) => {
  // Ставим флаг загрузки
  loadingDownload.value = true;

  downloadApi(
    "/leasing/downloadFile",
    {
      id: id,
    },
    id,
    progressDownload
  )
    .then((response) => {
      const jsonData =
        typeof response === "string" ? JSON.parse(response) : response;

      if (jsonData.error) {
        console.log({
          title: "Ошибка",
          msg: jsonData.error,
        });
      }
    })
    .finally(() => {
      loadingDownload.value = false;
    });
};
</script>